import React, { useState } from 'react';

import { Skeleton } from '@mui/material';
import styled, { CSSObject } from 'styled-components';

import ImageWithRetry from './ImageWithRetry';

interface Props {
  src: string;
  width: number | string;
  height: number | string;
  alt?: string;
  className?: string;
  imageStyle?: CSSObject;
  skeletonRadius?: string;
  handleLoad?: () => void;
}

function ImageWithSkeleton({
  src,
  alt,
  width,
  height,
  className,
  handleLoad,
  imageStyle,
  skeletonRadius = '8px',
}: Props) {
  const [isLoaded, setIsLoaded] = useState(false);

  const handleOnImageLoad = () => {
    handleLoad?.();
    setIsLoaded(true);
  };

  return (
    <SWrapper $isLoaded={isLoaded}>
      {!isLoaded && <Skeleton variant="rounded" width={width} height={height} sx={{ borderRadius: skeletonRadius }} />}
      <ImageWithRetry
        src={src}
        alt={alt}
        width={width}
        height={height}
        onLoad={handleOnImageLoad}
        className={`image-item ${className ?? ''}`}
        style={imageStyle}
      />
    </SWrapper>
  );
}

export default ImageWithSkeleton;

const SWrapper = styled.div<{ $isLoaded: boolean }>`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  border-radius: 8px;
  overflow: hidden;

  .image-item {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    visibility: ${({ $isLoaded: isLoaded }) => (isLoaded ? 'visible' : 'hidden')};
    border-radius: 8px;
    object-fit: cover;
    -webkit-user-drag: none;
    /* z-index: -1; */
  }
`;
